<template>
  <router-link class="Drop-Menu-Item" :to="{name: PATHS_NAME.STOREROOM}" @click="toClose"> 
    Кладовая
  </router-link>
</template>

<script setup>
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  //------------------------------------------
  const emit = defineEmits(['close-menu']);
  //------------------------------------------
  //Закрыть дропдаун
  const toClose = () => emit('close');
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>